import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface Props {
  label: string
  route: string
  resourceType: string
}

const ExpenseTypeCard = ({ label, route, resourceType }: Props) => {
  const trackEvent = () => {
    track(trackingEvents.expenses.goToExpensesFormSettings, {
      expense_type: resourceType,
    })
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
      <Text.Normal weight="semibold">{label}</Text.Normal>
      <Button.Router
        to={route}
        type="secondary"
        aria-label={label}
        onClick={() => trackEvent()}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default observer(ExpenseTypeCard)
